module.exports = __webpack_public_path__ + "media/streaming_reel.3d0c0932.webm";